import style from "css/room.module.css";
import React, { useRef } from "react";
import timelinePlugin from "@fullcalendar/timeline";
import interactionPlugin from "@fullcalendar/interaction";
import momentPlugin from "@fullcalendar/moment";
import FullCalendar from "@fullcalendar/react";
import dayjs from "dayjs";

const locale = "ko";
const timeZone = "Asia/Seoul";
const initialView = "timelineDay";
const dateFormat = "YYYY-MM-DD";
const dateTimeFormat = "YYYY-MM-DD HH:mm";
const slotDuration = 10;

/**
 * 파일명: Reserve.js
 * 작성자: 권도훈
 * 작성일자: 25.02.24
 * 설명: 모바일 페이지 회의실 현황 리소스 캘린더
 */
function Resource({ date, data, time, setTime, onEdit }) {
  const ref = useRef();

  const onDateClick = (info) => {
    const onClickDate = new Date(info.dateStr);
    const selectedDate = dayjs(onClickDate).format(dateTimeFormat);
    const endDate = dayjs(onClickDate)
      .add(slotDuration, "minute")
      .format(dateTimeFormat);

    ref.current.getApi().unselect();

    if (
      time.start === selectedDate ||
      onClickDate < new Date(date.format("YYYY-MM-DD HH:mm")) ||
      dayjs(new Date()).format(dateFormat) >
        dayjs(onClickDate).format(dateFormat)
    ) {
      setTime({
        start: "",
        end: "",
      });
      return;
    }

    if (
      (time.start === "" && time.end === "") ||
      new Date(time.start) > new Date(selectedDate) ||
      (new Date(time.start) < new Date(selectedDate) &&
        new Date(time.end) < new Date(selectedDate))
    ) {
      ref.current.getApi().select({
        start: selectedDate,
        end: endDate,
      });
      setTime({
        start: selectedDate,
        end: endDate,
      });
      return;
    }

    if (time.end === selectedDate) {
      ref.current.getApi().select({
        start: time.start,
        end: endDate,
      });
      setTime({ ...time, end: endDate });
      return;
    }

    if (new Date(time.end) > new Date(selectedDate)) {
      ref.current.getApi().select({
        start: time.start,
        end: endDate,
      });
      setTime({ ...time, end: endDate });
    }
  };
  return (
    <FullCalendar
      ref={ref}
      schedulerLicenseKey="0820383817-fcs-1688451544"
      plugins={[timelinePlugin, interactionPlugin, momentPlugin]}
      initialDate={date.format(dateFormat)}
      initialView={initialView}
      locale={locale}
      timeZone={timeZone}
      events={data}
      headerToolbar={false}
      nowIndicator={true}
      unselectAuto={true}
      views={{
        timelineDay: {
          // time
          slotDuration: "00:" + slotDuration + ":00",
          slotMinTime: "00:00:00",
          slotMaxTime: "24:00:00",
          // slot
          slotLabelClassNames: style.resource_header,
          slotLabelFormat: {
            hour: "numeric",
            minute: "2-digit",
            hour12: false,
          },
          // content
          eventClassNames: style.timeline_event,
          eventContent: (info) => {
            return (
              <p className={style.timeline_title}>{info.event._def.title}</p>
            );
          },
          slotLaneClassNames: (info) => {
            if (info.isPast) {
              return style.resource_disable_slot;
            }
          },
          eventClick: (arg) => {
            onEdit(arg.event._def.extendedProps.data);
          },
          dateClick: (info) => onDateClick(info),
        },
      }}
    />
  );
}

export default Resource;
